import { RouteName } from './route-names';
export const routePaths = {
    [RouteName.Main]: {
        en: '/',
        lv: '/',
        ru: '/',
    },
    [RouteName.AllStoresWithParameter]: {
        en: '/all-stores/:id',
        lv: '/visi-veikali/:id',
        ru: '/vse-mesta/:id',
    },
    [RouteName.AllStores]: {
        en: '/all-stores',
        lv: '/visi-veikali',
        ru: '/vse-mesta',
    },
    [RouteName.IqosStores]: {
        en: '/iqos-stores',
        lv: '/iqos-veikali',
        ru: '/iqos-mesta',
    },
    [RouteName.ResellerStores]: {
        en: '/:reseller-stores',
        lv: '/:reseller-veikali',
        ru: '/:reseller-mesta',
    },
    [RouteName.User]: {
        en: '/user',
        lv: '/lietotajs',
        ru: '/polzovatel',
    },
    [RouteName.Recharge]: {
        en: '/user/recharge',
        lv: '/lietotajs/uzlade',
        ru: '/polzovatel/podzaryadka',
    },
    [RouteName.Maintenance]: {
        en: '/user/maintenance',
        lv: '/lietotajs/uzturesana',
        ru: '/polzovatel/obsluzhivanie',
    },
    [RouteName.Clean]: {
        en: '/user/clean',
        lv: '/lietotajs/iztirit',
        ru: '/polzovatel/chistka',
    },
    [RouteName.Customize]: {
        en: '/user/customize',
        lv: '/lietotajs/pielagot',
        ru: '/polzovatel/personalizirovat',
    },
    [RouteName.Accessories]: {
        en: '/user/customize/accessories',
        lv: '/lietotajs/pielagot/aksesuari',
        ru: '/polzovatel/personalizirovat/aksessuary',
    },
    [RouteName.Engraving]: {
        en: '/user/customize/engraving',
        lv: '/lietotajs/pielagot/gravejums',
        ru: '/polzovatel/personalizirovat/gravirovka',
    },
    [RouteName.BuyHeets]: {
        en: '/user/buy-heets',
        lv: '/lietotajs/karsejamo-tabakas-produktu-iegade',
        ru: '/polzovatel/kupit-izdeliia-iz-nagrevaemogo-tabaka',
    },
    [RouteName.BuyIqos]: {
        en: '/buy-iqos',
        lv: '/rezervet-iqos',
        ru: '/zabroniruj-iqos',
    },
    [RouteName.BuyBonds]: {
        en: '/buy-bonds',
        lv: '/rezervet-bonds',
        ru: '/zabroniruj-bonds',
    },
    [RouteName.New]: {
        en: '/new',
        lv: '/jauns',
        ru: '/novyi',
    },
    [RouteName.LendIqos]: {
        en: '/new/lend-iqos',
        lv: '/jauns/aizdot-iqos',
        ru: '/novyi/testirovat-iqos',
    },
    [RouteName.Contact]: {
        en: '/contact',
        lv: '/kontakti',
        ru: '/kontakty',
    },
    [RouteName.SubmitQuestion]: {
        en: '/contact/question',
        lv: '/kontakti/jautajums',
        ru: '/kontakty/voprosy',
    },
};
